import script from "./Customer.vue?vue&type=script&lang=ts&setup=true"
export * from "./Customer.vue?vue&type=script&lang=ts&setup=true"

import "./Customer.vue?vue&type=style&index=0&id=052f655a&lang=scss"
import "./Customer.vue?vue&type=style&index=1&id=052f655a&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-052f655a"]])

export default __exports__